module.exports = __webpack_public_path__ + "static/cinematography-e784757e8aaf9f00a5c6c2ba77939b64.jpg";